// import Vue from 'vue';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/css/app.css';
import BackToTop from 'vue-backtotop';
import VueGtag from "vue-gtag";
	// .use(VueAnalytics, {id: 'G-EW1S97LQSC'})


const feather = require('feather-icons');
feather.replace();



createApp(App).use(VueGtag, {
	config: { id: "G-EW1S97LQSC" }
  })
	.use(router)
	.use(BackToTop)
	.mount('#app');

	
const appTheme = localStorage.getItem('theme');

// Check what is the active theme and change theme when user clicks on the theme button in header.
if (
	appTheme === 'dark' &&
	document.querySelector('body').classList.contains('app-theme')
) {
	document.querySelector('body').classList.add('bg-primary-dark');
} else {
	document.querySelector('body').classList.add('bg-secondary-light');
}
